import React from 'react';

const Node = ({ title, detail, kind = 'external' }) => (
  <div className={`flow-node flow-node-${kind}`}>
    <strong>{title}</strong>
    {detail && <span>{detail}</span>}
  </div>
);

const Spine = ({ label }) => (
  <div className="flow-row">
    <div className="flow-spine">{label && <span>{label}</span>}</div>
  </div>
);

const Link = ({ direction }) => <div className={`flow-link flow-link-${direction}`} />;

const PipelineDiagram = () => (
  <figure
    className="flow"
    aria-label="AI testing pipeline. A team uploads requirements and use cases. An intake agent reads code repositories and produces a system map. A test-writer agent turns it into a test suite. An execution agent runs the suite against test services. Results are verified against pre-production logs and shown in code review."
  >
    <div className="flow-row">
      <Node title="Requirements + use cases" detail="Uploaded by a team" />
    </div>
    <Spine />

    <div className="flow-system">
      <div className="flow-system-header">
        <strong>AI testing platform</strong>
        <span>AWS Lambda + Amazon Bedrock</span>
      </div>

      <div className="flow-row">
        <Node kind="agent" title="Intake agent" detail="Maps the system" />
        <Link direction="left" />
        <Node title="Code repositories" detail="Services, APIs, data flows" />
      </div>
      <Spine label="System map" />

      <div className="flow-row">
        <Node kind="agent" title="Test-writer agent" detail="Writes the test cases" />
      </div>
      <Spine label="Test suite" />

      <div className="flow-row">
        <Node kind="agent" title="Execution agent" detail="Runs each case end to end" />
        <Link direction="right" />
        <Node title="Live test services" detail="Synthetic test data" />
      </div>
      <Spine label="Execution traces" />

      <div className="flow-row">
        <Node kind="step" title="Verification" detail="Proves each case worked" />
        <Link direction="left" />
        <Node title="Pre-production logs" detail="No real user data" />
      </div>
    </div>

    <Spine label="Verified results" />
    <div className="flow-row">
      <Node title="Code review" detail="Evidence for the reviewer" />
    </div>
  </figure>
);

export default PipelineDiagram;
